import PropTypes from 'prop-types';
import React from 'react';

/**
 * A Draggable element, only it is not draggable for now
 */
export default class Draggable extends React.Component {
    render() {
        return (
            <div
                className="draggable"
                style={{
                    position: 'fixed',
                    top: `${this.props.position.y}px`,
                    left: `${this.props.position.x}px`,
                    zIndex: '15'
                }}
            >
                {this.props.children}
            </div>
        );
    }
}

Draggable.defaultProps = {
    zIndex: 15
};

Draggable.propTypes = {
    children: PropTypes.node.isRequired,
    handle: PropTypes.string,
    position: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number
    }).isRequired,
    static: PropTypes.bool,
    zIndex: PropTypes.number
};
